import { onFontsReady } from "../utils/onFontsReady";
import { initFontsGate } from "../utils/initFontsGate";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
initFontsGate("Manrope", [400, 700]);

function initGmap(root) {
  if (!root || root.dataset.gsapGmapInited) return;
  root.dataset.gsapGmapInited = "1";

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const frame = root.querySelector(".wv-gmap__frame");
  if (!frame) return;

  gsap.set(frame, { opacity: 0 });

  gsap.to(frame, {
    opacity: 1,
    duration: 1.0,
    ease: "power1.out",
    clearProps: "opacity",
    scrollTrigger: {
      trigger: root,
      start: "top 70%",
      once: true,
      invalidateOnRefresh: true,
      // markers: true,
    },
  });
}

onFontsReady(() => {
  document.querySelectorAll(".wv-gmap").forEach(initGmap);
  ScrollTrigger.refresh();
});
